import { BaseCL } from "./MuWidget/BaseCL";
import { UiFlashContainer } from "./Ui/UiFlash";

export class BaseBackend extends BaseCL {
    constructor() {
        super();
        this.onError = (err) => {
            UiFlashContainer.add("Došlo k chybe při komunikaci se serverem.");
            console.log(err);
        }

        this.onLoading = m => UiFlashContainer.add("Komunikuji se serverem", "loader");
        this.onLoaded = l => l.muRemoveSelf();
    }
}